module.exports = __webpack_public_path__ + "img/cti_roads_horizontal.b5eca8ad.svg";